/* globals __TEST__ */
/**
 * App configuration - a mix of defaults and detected
 * environment settings.
 */
import _ from "lodash";
import defaults from "defaultConfig";
import environments from "environmentConfig";
import { getDecodedQueryParamsFromWindow } from "util/uriUtil";
import packageJson from "../package.json";

function buildUri(object) {
    let uri = "";
    if (object.protocol && object.hostname) {
        uri += object.protocol + "://";
    }
    if (object.hostname) {
        uri += object.hostname;
    }
    if (object.port && object.hostname) {
        uri += ":" + object.port;
    }
    if (object.path) {
        if (!object.path.match("^/")) {
            uri += "/";
        }
        uri += object.path;
    }

    return uri;
}

let envOverride = "";
let envConfig = {};
let apiUri = "";
let journeyUri = "";
let journeyHawkUri = "";
let giaTranscriptUri = "";
let giaTranscriptV2Uri = "";
let qualityFormsUri = "";
let appVersion = "";

if (!__TEST__) {
    envOverride = getDecodedQueryParamsFromWindow().env;
    let environment = _.find(environments, (_value_, key) =>
        window.location.hostname.match(key + "$")
    );

    if (envOverride) {
        environment =
            _.find(environments, (env) => env.envName === envOverride) ||
            environment;
    }

    // Use default values if we're not in a recognized environment
    envConfig = environment
        ? Object.assign({}, defaults, environment)
        : Object.assign(
              {},
              defaults,
              environments[defaults.defaultEnvironment]
          );

    apiUri = buildUri(envConfig.api);
    journeyUri = buildUri(envConfig.journey);
    journeyHawkUri = buildUri(envConfig.journey_micro);
    giaTranscriptUri = buildUri(envConfig.giaTranscript);
    giaTranscriptV2Uri = buildUri(envConfig.giaTranscriptV2);
    qualityFormsUri = buildUri(envConfig.qualityForms);
    appVersion = document
        .querySelector('head meta[name="app-version"]')
        .getAttribute("content");
} else {
    apiUri = "mockedApiUri";
}

const config = {
    envName: "pca",
    ...envConfig,
    api: { uri: apiUri },
    journey: { uri: journeyUri },
    journey_micro: { uri: journeyHawkUri },
    giaTranscript: { uri: giaTranscriptUri },
    giaTranscriptV2: { uri: giaTranscriptV2Uri },
    qualityForms: { uri: qualityFormsUri },
    appVersion,
    appName: defaults.appName,
    packageVersion: packageJson.version,
};

export default config;
